import { createCustomerLocation } from 'core/api/customer.api';
// eslint-disable-next-line no-unused-vars
import { IDraftLocation } from 'shared/widgets/Locations/Locations.models';
import {
  createLocationRequest,
  createLocationSuccess,
  createLocationFailure,
} from 'pages/Customers/CustomersLocations/CreateLocation/actionCreators';

const createLocationAction = (
  customerId: number | string,
  formData: IDraftLocation,
) => async (dispatch) => {
  try {
    dispatch(createLocationRequest());
    const { data } = await createCustomerLocation(customerId, formData);
    dispatch(createLocationSuccess(data));
  } catch (error) {
    dispatch(createLocationFailure(error));
    throw error;
  }
};

export default createLocationAction;
